export function CpfFormat(event:any) {
    const { value } = event.target;
    const formattedValue = value
      .replace(/\D/g, "") // Remove all non-digit characters
      .replace(/(\d{3})(\d)/, "$1.$2") // Add a dot after 3 digits
      .replace(/(\d{3})(\d)/, "$1.$2") // Add a dot after the next 3 digits
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2"); // Add a hyphen before the last 1 or 2 digits
  
    event.target.value = formattedValue;
  }